import React from 'react';

const CustomizedAxisTick = ({ x, y, payload }) => {
  return (
    <g transform={`translate(${x},${y})`}>
      <text
        x={0}
        y={0}
        dy={16}
        textAnchor="start"
        fill="#00000099"
        transform="rotate(35)"
      >
        {payload.value}
      </text>
    </g>
  );
};

export default CustomizedAxisTick;